import palmJumeirahImg from "../Assets/location/Palm-Jumeirah.webp";
import dubaiMarinaImg from "../Assets/location/dubai-marina.webp";
import downtownDubaiImg from "../Assets/location/Downtown_Dubai.webp";
import bluewatersImg from "../Assets/location/Bluewaters-Island.webp";
import jbrImg from "../Assets/location/Jumeirah-Beach-Residence.webp";
import emaarBeachfrontImg from "../Assets/location/Emaar-beachfront.webp";
import jvcImg from "../Assets/location/Jumeirah-Village-Circle.webp";
import districtOneImg from "../Assets/location/District-One.webp";
import dubaiImg from "../Assets/location/Dubai.webp";

const locations = [
  {
    id: 1,
    slug: "palm-jumeirah",
    name: "Palm Jumeirah",
    tagline: "The Iconic Island Retreat",
    image: palmJumeirahImg,
    hero: {
      title: "Luxury Holiday Villas & Apartments on Palm Jumeirah",
      subtitle:
        "Experience the world’s most famous island with private beaches and resort-style living.",
    },
    intro:
      "Palm Jumeirah, Dubai's iconic man-made island, is famous for its luxury resorts, pristine beaches, stunning sea views, and vibrant dining. Ideal for relaxation, scenic drives, or waterfront strolls, the island offers breathtaking vistas of the Dubai skyline and the Arabian Gulf, blending leisure, luxury, and serenity.",
    lifestyle: {
      dining: [
        "West Beach – Beach clubs like Kyma and Surf Club",
        "The Pointe – Waterfront dining with fountain views",
        "Atlantis The Royal – Nobu by the Beach, Dinner by Heston",
      ],
      activities: [
        "Aquaventure Waterpark",
        "Nakheel Mall",
        "The View at The Palm",
      ],
    },
    faq: [
      {
        q: "Where is Palm Jumeirah located in Dubai?",
        a: "Situated off Dubai's coast in the Arabian Gulf, Palm Jumeirah connects seamlessly to Dubai Marina and Jumeirah Beach Residence (JBR), offering prime waterfront living.",
      },
      {
        q: "What lifestyle experiences can I enjoy on Palm Jumeirah?",
        a: "Residents and visitors can indulge in yacht cruises, private beach clubs, fine dining by celebrity chefs, spa retreats, and scenic promenade walks, all in an exclusive setting.",
      },
      {
        q: "Who is the developer behind Palm Jumeirah?",
        a: "Palm Jumeirah was masterfully developed by Nakheel, a leading Dubai developer, creating a globally recognized symbol of luxury, innovation, and waterfront elegance.",
      },
      {
        q: "How accessible is Palm Jumeirah from other parts of Dubai?",
        a: "Palm Jumeirah is easily accessible via Sheikh Zayed Road and the Palm Jumeirah Monorail, connecting residents and visitors to Dubai Marina, Downtown Dubai, and other key destinations.",
      },
    ],
  },

  {
    id: 2,
    slug: "dubai-marina",
    name: "Dubai Marina",
    tagline: "The Vertical City",
    image: dubaiMarinaImg,
    hero: {
      title: "Luxury Vacation Rentals in Dubai Marina",
      subtitle:
        "Waterfront living with skyline views, superyachts, and urban energy.",
    },
    intro:
      "Dubai Marina is renowned for its ultra-modern skyline, a man-made marina filled with luxury yachts, and a vibrant waterfront lifestyle. From strolling along Marina Walk to dining, shopping at Dubai Marina Mall, and visiting nearby JBR Beach, it's a hub for luxury living, entertainment, watersports, and tourism.",
    lifestyle: {
      dining: [
        "Pier 7 – Seven restaurants with marina views",
        "Asia Asia – Pan-Asian fine dining",
        "Marina Walk – Al fresco waterfront dining",
      ],
      activities: [
        "Marina Yacht Cruises",
        "XLine Zipline",
        "Dubai Marina Mall",
      ],
    },
    faq: [
      {
        q: "What lifestyle experiences can I enjoy in Dubai Marina?",
        a: "Residents and visitors can enjoy yacht cruises, waterfront dining, boutique shopping, leisure strolls along the Marina Walk, and vibrant nightlife in a cosmopolitan setting.",
      },
      {
        q: "How accessible is Dubai Marina from other parts of Dubai?",
        a: "Dubai Marina is well-connected via Sheikh Zayed Road, Dubai Metro, and tram services, providing easy access to Downtown Dubai, Palm Jumeirah, and other key destinations.",
      },
      {
        q: "How accessible is Dubai Marina by public transport?",
        a: "Dubai Marina is well-connected via the Dubai Metro, tram services, taxis, and nearby roads, making it easy for guests to reach major attractions and other parts of the city.",
      },
      {
        q: "What is the lifestyle like in Dubai Marina?",
        a: "Dubai Marina offers a cosmopolitan lifestyle with luxury dining, vibrant nightlife, leisure promenades, watersports, yacht clubs, and premium shopping options.",
      },
    ],
  },

  {
    id: 3,
    slug: "downtown",
    name: "Downtown Dubai",
    tagline: "The Center of Now",
    image: downtownDubaiImg,
    hero: {
      title: "Luxury Holiday Apartments in Downtown Dubai",
      subtitle:
        "Stay in the shadow of the Burj Khalifa and the Dubai Fountains.",
    },
    intro:
      "Downtown Dubai, the heart of the city, is famous for its iconic Burj Khalifa, luxurious hotels, upscale residences, and vibrant lifestyle. Visitors can enjoy fine dining, high-end shopping at The Dubai Mall, and scenic walks around the Dubai Fountain. Blending modern architecture, entertainment, and leisure, Downtown Dubai is a prime destination for luxury living and unforgettable experiences.",
    lifestyle: {
      dining: [
        "Souk Al Bahar – Fountain-view dining",
        "Time Out Market",
        "Dubai Opera",
      ],
      activities: [
        "Burj Khalifa – At The Top",
        "Dubai Fountain Show",
        "Burj Park",
      ],
    },
    faq: [
      {
        q: "Why is Downtown Dubai a top location for short-term stays?",
        a: "Downtown Dubai is at the heart of the city, offering iconic views of Burj Khalifa, Dubai Fountain, and easy access to luxury hotels, fine dining, and premium shopping, making it perfect for holiday stays.",
      },
      {
        q: "How close is Downtown Dubai to major attractions?",
        a: "Downtown Dubai is within walking distance or a short drive to Dubai Mall, Burj Khalifa, Dubai Opera, and Souk Al Bahar, with quick access to Sheikh Zayed Road and other city hubs.",
      },
      {
        q: "What lifestyle experiences can guests enjoy in Downtown Dubai?",
        a: "Guests can enjoy world-class dining, scenic fountain shows, shopping at luxury malls, rooftop lounges, cultural events, and relaxing walks along the boulevards.",
      },
      {
        q: "Can I enjoy dining and entertainment within walking distance?",
        a: "Yes, Downtown Dubai offers world-class restaurants, rooftop lounges, cafes, and cultural venues like Dubai Opera, all within walking distance of most luxury apartments.",
      },
    ],
  },

  {
    id: 4,
    slug: "bluewaters-island",
    name: "Bluewaters Island",
    tagline: "The Urban Island Sanctuary",
    image: bluewatersImg,
    hero: {
      title: "Exclusive Vacation Rentals on Bluewaters Island",
      subtitle:
        "A private island retreat featuring Ain Dubai and sophisticated dining.",
    },
    intro:
      "Bluewaters Island, Dubai's vibrant lifestyle destination, features luxury hotels, waterfront residences, and over 200 retail and dining concepts. Home to the record-breaking Ain Dubai observation wheel, it offers entertainment, leisure, and scenic seaside experiences. With promenades, beach clubs, and stunning views, Bluewaters blends modern living, tourism, and unforgettable waterfront attractions.",
    lifestyle: {
      dining: [
        "Alici – Amalfi Coast seafood",
        "The Pods – Private dining bubbles",
        "Banyan Tree Dubai",
      ],
      activities: ["Madame Tussauds", "Sunset promenade walks", "Cove Beach"],
    },
    faq: [
      {
        q: "What types of accommodations are available on Bluewaters Island?",
        a: "Guests can enjoy modern serviced apartments, stylish residences, and exclusive waterfront properties, many with access to private terraces, balconies, and stunning sea views.",
      },
      {
        q: "What dining and entertainment options are available on Bluewaters Island?",
        a: "The island features over 200 restaurants, cafes, beach clubs, retail outlets, and entertainment venues, including the iconic Ain Dubai observation wheel for unforgettable experiences.",
      },
      {
        q: "Is Bluewaters Island family-friendly?",
        a: "Yes, families can enjoy safe promenades, interactive attractions, beachside leisure areas, and kid-friendly dining options, making it ideal for family vacations.",
      },
      {
        q: "How accessible is Bluewaters Island from other parts of Dubai?",
        a: "Bluewaters Island is well-connected via Sheikh Zayed Road and pedestrian bridges from JBR, Dubai Marina, and the beach, ensuring easy access for tourists and guests.",
      },
    ],
  },

  {
    id: 5,
    slug: "jbr",
    name: "Jumeirah Beach Residence (JBR)",
    tagline: "Beach, Buzz, and Carnival Vibes",
    image: jbrImg,
    hero: {
      title: "Beachfront Holiday Apartments in JBR",
      subtitle: "Direct beach access with endless entertainment.",
    },
    intro:
      "Jumeirah Beach Residence (JBR) is Dubai's iconic waterfront community, known for its pristine beaches, luxury apartments, and vibrant Marina Walk promenade. With diverse dining, shopping, beach clubs, and watersports, JBR offers a lively lifestyle by the sea. Perfect for relaxation, leisure, and entertainment, it combines modern living with stunning seaside experiences.",
    lifestyle: {
      dining: ["Bla Bla Dubai", "The Beach Mall", "Flying Cup"],
      activities: ["Jet skiing & parasailing", "AquaFun water park"],
    },
    faq: [
      {
        q: "What dining and entertainment options are near JBR?",
        a: "JBR features a wide selection of restaurants, cafes, beach clubs, boutique shopping, and entertainment along The Walk, offering guests a lively and luxurious experience.",
      },
      {
        q: "What lifestyle experiences can I enjoy along JBR?",
        a: "Guests can stroll along The Walk, dine at world-class beachfront restaurants, unwind at beach clubs, enjoy watersports, or simply watch spectacular sunsets over the Arabian Gulf.",
      },
      {
        q: "Is JBR suitable for families and groups?",
        a: "Absolutely. JBR offers safe promenades, kid-friendly beaches, and family-oriented dining and leisure options, making it perfect for families, friends, and groups seeking a premium vacation.",
      },
      {
        q: "How connected is JBR to other luxury destinations in Dubai?",
        a: "JBR is a gateway to Dubai Marina, Palm Jumeirah, and Downtown Dubai, offering guests easy access to high-end attractions, shopping, nightlife, and city experiences.",
      },
    ],
  },

  {
    id: 6,
    slug: "emaar-beachfront",
    name: "Emaar Beachfront",
    tagline: "Miami Vibes in Dubai",
    image: emaarBeachfrontImg,
    hero: {
      title: "Exclusive Rentals at Emaar Beachfront",
      subtitle: "A gated private island with Miami-style luxury.",
    },
    intro:
      "Emaar Beachfront, a luxurious gated island in Dubai Harbour, lies between Jumeirah Beach Residence (JBR) and Palm Jumeirah. Developed by Emaar Properties, it offers luxury apartments with private beach access, stunning sea views, and world-class amenities. Residents can enjoy beach clubs, fine dining, leisure activities, and scenic promenades, combining modern living, tranquility, and an unmatched seaside lifestyle.",
    lifestyle: {
      dining: [
        "L’Amo Bistro del Mare",
        "Bar Du Port",
        "Dubai Harbour promenade",
      ],
    },
    faq: [
      {
        q: "Can guests access private beach and leisure facilities?",
        a: "Yes, Emaar Beachfront provides private beach access, beach clubs, swimming pools, and landscaped promenades for ultimate relaxation and luxury experiences.",
      },
      {
        q: "How convenient is Emaar Beachfront for exploring Dubai?",
        a: "Located between JBR and Palm Jumeirah, Emaar Beachfront provides easy access to Dubai Marina, Downtown Dubai, and major highways, allowing guests to explore the city effortlessly.",
      },
      {
        q: "Can guests enjoy yacht and water experiences at Emaar Beachfront?",
        a: "Yes, guests can book yacht cruises, enjoy water sports, or relax by the marina, offering an exclusive waterfront lifestyle right at their doorstep.",
      },
      {
        q: "What dining experiences are available at Emaar Beachfront?",
        a: "The community offers a range of fine dining restaurants, beachside cafes, and luxury lounges, perfect for a premium culinary experience with stunning sea views.",
      },
    ],
  },

  {
    id: 7,
    slug: "jumeirah-village-circle",
    name: "Jumeirah Village Circle (JVC)",
    tagline: "The Garden Community",
    image: jvcImg,
    hero: {
      title: "Family Holiday Homes in JVC",
      subtitle: "Spacious, serene living surrounded by parks.",
    },
    intro:
      "Jumeirah Village Circle (JVC) is a popular, family-friendly, freehold community in Dubai developed by Nakheel. Offering a mix of modern villas, townhouses, and apartments, it features landscaped parks, leisure facilities, and retail options. With its community-focused environment, convenience, and contemporary living, JVC is ideal for families, professionals, and investors seeking quality homes in Dubai.",
    lifestyle: {
      dining: [
        "Circle Mall",
        "FIVE Jumeirah Village",
        "Community parks & cafes",
      ],
    },
    faq: [
      {
        q: "Why choose JVC for a luxury short-term stay?",
        a: "Jumeirah Village Circle offers a peaceful, family-friendly environment with modern villas and apartments, landscaped green spaces, and convenient access to Dubai's top attractions.",
      },
      {
        q: "How convenient is JVC for exploring Dubai?",
        a: "JVC is centrally located, with easy access to Sheikh Zayed Road, Downtown Dubai, Dubai Marina, and Palm Jumeirah, making it perfect for tourists and holiday guests.",
      },
      {
        q: "Are there dining and shopping options near JVC?",
        a: "Yes, JVC is close to retail centers, cafes, restaurants, and supermarkets, providing guests with convenience and a vibrant community lifestyle.",
      },
      {
        q: "What lifestyle experiences can guests enjoy in JVC?",
        a: "Guests can enjoy a tranquil lifestyle with access to jogging trails, cycling paths, landscaped parks, nearby dining options, and a peaceful retreat from the city's bustle.",
      },
    ],
  },

  {
    id: 8,
    slug: "district-one",
    name: "District One",
    tagline: "The Green Heart of Dubai",
    image: districtOneImg,
    hero: {
      title: "Ultra-Luxury Villas in District One",
      subtitle: "Mansions surrounding the world’s largest Crystal Lagoon.",
    },
    intro:
      "District One, located in Mohammed Bin Rashid City, Dubai, is a luxurious residential community renowned for its expansive green spaces, crystal-clear lagoons, and high-end villas. Offering private waterfront access, world-class amenities, and serene surroundings, it blends modern living with tranquility. Residents enjoy leisure, wellness, and outdoor activities, making District One a premier address for luxury and exclusivity in Dubai.",
    lifestyle: {
      activities: [
        "Crystal Lagoon swimming",
        "Meydan Racecourse",
        "Nearby Downtown Dubai",
      ],
    },
    faq: [
      {
        q: "Can guests enjoy outdoor activities at District One?",
        a: "Absolutely. Guests can stroll along scenic pathways, cycle through the community, relax by the lagoons, or enjoy yoga and wellness sessions in tranquil surroundings.",
      },
      {
        q: "Is District One suitable for corporate stays or events?",
        a: "Yes, the spacious villas and luxury amenities make District One ideal for corporate retreats, private meetings, or hosting small, exclusive events in a premium setting.",
      },
      {
        q: "What makes District One ideal for couples and honeymoon stays?",
        a: "District One offers a romantic and tranquil environment, perfect for couples seeking privacy and luxury.",
      },
      {
        q: "Are there recreational activities within District One?",
        a: "Absolutely. Guests can enjoy jogging and cycling paths, water sports, yoga spots, and scenic walks along the lagoons, blending wellness and leisure in a luxurious setting.",
      },
    ],
  },

  {
    id: 9,
    slug: "dubai",
    name: "Dubai",
    tagline: "The City of Superlatives",
    image: dubaiImg,
    hero: {
      title: "Luxury Vacation Rentals Across Dubai",
      subtitle:
        "Explore the entire city with our curated collection of premium properties.",
    },
    intro:
      "Dubai is a dynamic global metropolis where futuristic architecture meets rich Arabian heritage. The city seamlessly blends ultramodern skyscrapers like the Burj Khalifa with traditional souks and cultural districts, offering pristine beaches, world-class shopping malls, Michelin-starred dining, and endless entertainment across diverse neighborhoods.",
    lifestyle: {
      dining: [
        "Michelin-starred restaurants across the city",
        "Traditional Arabic dining in Old Dubai",
        "Rooftop bars with skyline views",
        "International cuisine from every corner of the world",
      ],
      activities: [
        "Dubai Mall & Mall of the Emirates",
        "Desert safaris & dune bashing",
        "Gold & Spice Souks in Deira",
        "Ski Dubai indoor skiing",
        "Global Village",
        "IMG Worlds of Adventure",
      ],
    },
    faq: [
      {
        q: "What's the best time to visit Dubai?",
        a: "November to March offers the most pleasant weather, with temperatures ranging from 20-30°C.",
      },
      {
        q: "Is Dubai family-friendly?",
        a: "Absolutely! Dubai offers countless family attractions, safe environments, and world-class facilities.",
      },
      {
        q: "Do I need a car in Dubai?",
        a: "Not necessarily. Dubai has excellent public transport, taxis, and ride-hailing services, though having a car offers more flexibility.",
      },
    ],
  },
];

export default locations;
